import { combineReducers } from "redux";
function createReducer(ducks) {
    const base = {};
    const extensions = Object.keys(ducks)
        .map(key => ({ key, reducer: ducks[key].reducer }))
        .filter(item => typeof item.reducer === "function")
        .reduce((prev, current) => (Object.assign(Object.assign({}, prev), { [current.key]: current.reducer })), {});
    const reducers = combineReducers(Object.assign(Object.assign({}, base), extensions));
    return reducers;
}
export default createReducer;
//# sourceMappingURL=reducers.js.map